
<div *ngIf="profileState === 0">

  <app-loading-spinner [loading]="isLoading">

    <div style="max-width: 315px">
      {{'PROFILES.INFOTEXT'|translate}}
    </div>

  <div class="form-check">
    <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" (click)="onClickRadioLoad()">
    <label class="form-check-label" [ngStyle]="{'color': (selectError==true) ? 'red' : null}" for="flexRadioDefault1">
      {{'PROFILES.LOAD'|translate}}
    </label>
  </div>
  <div class="form-check">
    <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" (click)="onClickRadioSave()">
    <label class="form-check-label" [ngStyle]="{'color': (selectError==true) ? 'red' : null}" for="flexRadioDefault2">
      {{'PROFILES.SAVE'|translate}}
    </label>
  </div>

  <!-- dummy element for local file select -->
  <input #FileSelectInputDialog type="file" (change)="import($event.target.files)"/>

  <div style="height:60px;margin-top:20px">
    <div *ngIf="!scgShared.isMobile()" (click)="toggleAdvanced()">
      <span *ngIf="!isAdvanced">&#9660;</span>
      <span *ngIf="isAdvanced">&#9650;</span>
      {{'COMMON.ADVANCED'|translate}}
    </div>
    <span *ngIf="!scgShared.isMobile() && isAdvanced">
        <input type="checkbox" class="m-2" [(ngModel)]="wantLocal"> {{'PROFILES.USE_LOCAL'|translate}}
      </span>
  </div>

  </app-loading-spinner>
</div>


<!-- LOAD Are you sure msg -->
<div *ngIf="profileState === 6">
  {{overwriteCaption}}
</div>

<!-- SAVE Exists message -->
<div *ngIf="profileState === 5">
  {{'PROFILES.EXISTS' | translate }}
</div>

<!-- LOAD OR SAVE DIALOG -->
<div *ngIf="profileState === 1 || profileState === 2">
  <app-loading-spinner [loading]="isLoading">

   <div *ngIf="wantLocal===false">

     <div class="row">
     <div class="col-12">
       <div class="float-right mb-1">
        <button (click)="deleteSelectedProfile()"
                [disabled]="filename===''"
                [ngClass]="{'scg-link-native-disabled': selectedItem.length==0,'scg-link-native': selectedItem.length>0}"
                class=" text-uppercase">{{'BUTTON.DELETE'|translate}}</button>
      </div>
     </div>
     </div>

     <div class="row">
      <div class="col-12">
     <div class="table-wrap">
       <table class="table table-bordered table-hover table-sm">
         <tbody>
         <tr *ngFor="let item of profileItem" [ngClass]="{ 'scg-hover':  selectedItem == item.fileName}">
           <td (click)="setSavename(item.fileName)">
             {{item.fileName}}
           </td>
         </tr>
         </tbody>
       </table>
     </div>
    </div>
    </div>
   </div>


        <div *ngIf="profileState==2">
            <div style="margin-top:25px;margin-bottom:5px"
                 [ngStyle]="{'color': (saveError===true) ? 'red' : '#333'}">
              {{'PROFILES.NAME'|translate}}
            </div>
            <div>
              <input #savename type="text" [(ngModel)]="filename" ngModel maxlength="30"
                     (keypress)="resetError()" style="width:100%" autofocus>
              <div style="height:30px"></div>
            </div>
        </div>

        <div *ngIf="selectError===true" class="mt-3 scg-note-error">
          {{'COMMON.PLEASE_SELECT'|translate}}
        </div>
  </app-loading-spinner>
</div>







